// Remembers the app link a logged-out user tried to open (e.g. an email button),
// so the login can send them there instead of to their role's start page.
// Kept in sessionStorage: it belongs to this tab and is gone once used.
const STORAGE_KEY = "redirectAfterLogin";

// Only same-site app paths; never auth pages or protocol-relative URLs ("//evil.com").
const isSafeAppPath = (path) =>
   typeof path === "string" &&
   path.startsWith("/") &&
   !path.startsWith("//") &&
   !path.startsWith("/auth") &&
   path !== "/";

export function rememberRedirectAfterLogin(location) {
   const path = `${location.pathname}${location.search}${location.hash}`;
   if (!isSafeAppPath(path)) return;
   try {
      sessionStorage.setItem(STORAGE_KEY, path);
   } catch (e) {
      // Storage unavailable (private mode etc.): the user just lands on the start page.
   }
}

// Returns the remembered path once, then forgets it.
export function takeRedirectAfterLogin() {
   try {
      const path = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      return isSafeAppPath(path) ? path : null;
   } catch (e) {
      return null;
   }
}
